import { registry } from '@cian/mf-registry/browser';

import { IOpenAuthModalParameters } from '../../shared/repositories/header-frontend/v2/get-header-microfrontend/microfrontend/api/v2/open-auth-modal/types';

export async function makeApiCall<Params, Result>(path: string, params: Params) {
  const api = await registry().microfrontendStrict('header-frontend').api()?.ensure();

  if (api) {
    return api.call<Params, Result>(path, params);
  }

  return;
}

export const getHeaderMicrofrontendApi = () => {
  return {
    openAuthModal: (autoRefresh: boolean = false) =>
      makeApiCall<IOpenAuthModalParameters, void>('/v2/open-auth-modal/', { autoRefresh }),
  };
};
